<div class="d-flex justify-content-center" style="flex: 1">

    <p-dataView #dv
                [value]="items"
                [paginator]="false"
                [totalRecords]="this.primengTableHelper.totalRecordsCount">

        <ng-template let-product pTemplate="listItem">
            <div class="col-sm-12 col-md-4">
                <div class="product-grid-item card">
                    <div class="product-grid-item-top">

                        <div *ngFor="let category of product.categories">
                            <i class="pi pi-tag product-category-icon"></i>
                            <span class="product-category">{{category.shortName}}</span>
                        </div>

                        <span *ngIf="product.amount > 1" class="product-badge amount-box">
                            {{product.amount}}
                            <span *ngIf="product.amount > 1" translation="Axilla.OrderGuide.Article.AmountBox" source="Axilla">
                            </span>
                        </span>
                    </div>
                    <div class="product-grid-item-content">

                        <div class="product-image">
                            <div class="product-image-helper"></div>
                            <img src="{{getImgUrl(product.code)}}" alt="Article picture" />
                        </div>
                        <div class="product-name">{{product.title}}</div>
                        <div class="product-description">{{product.description}}</div>
                        <!--<p-rating [value]="5" [readonly]="true" [cancel]="false"></p-rating>-->
                    </div>

                    <div class="product-grid-item-bottom">
                        <span class="product-price">{{product.price | currency:getCurrency(product.currency):'symbol-narrow':'.2-2'}}</span>
                        <div class="tile-view shop-actions" (click)="preventClick($event)">
                            <p-button
                                icon="pi pi-shopping-cart"
                                label="Add"
                                (click)="addAdditionalArticle($event, product)"></p-button>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>

    </p-dataView>
    <div class="spinner-container" *ngIf="isLoadingArticles">
        <p-progressSpinner></p-progressSpinner>
    </div>
</div>
